import { render, staticRenderFns } from "./AIScreen.vue?vue&type=template&id=5cd0a9d8&scoped=true"
import script from "./AIScreen.vue?vue&type=script&lang=js"
export * from "./AIScreen.vue?vue&type=script&lang=js"
import style0 from "./AIScreen.vue?vue&type=style&index=0&id=5cd0a9d8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cd0a9d8",
  null
  
)

export default component.exports